import React from "react";
import { Table, TableCell, TableContainer } from "@mui/material";
import {
  colonCellStyle,
  labelCellStyle,
  StyledTableBody,
  TableBodyRow,
  valueCellStyle,
} from "../../styles/TableStyles";
import { INDIAN_RUPEE_SIGN } from "../../constant/constant";
import { formatedDateIST } from "../../utils/utils";

const TenantDetailsTable = ({ tenant }) => {
  const tenantDetails = [
    ["Name", `${tenant.tenant_first_name} ${tenant.tenant_last_name}`],
    ["Contact", tenant.tenant_contact],
    ["Aadhar/PAN Number", tenant.uid_number],
    ["Rental Property", `${tenant.building_name}, ${tenant.property_name}`],
    ["Entry Date", formatedDateIST(tenant.entry_date)],
    ["Exit Date", tenant.exit_date],
    ["Annual Increment Date", formatedDateIST(tenant.annual_increment_date)],
    ["Rent Amount", `${INDIAN_RUPEE_SIGN} ${tenant.rent_amount}`],
    ["GST", tenant.is_gst_check ? "Yes" : "No"],
    tenant.is_gst_check && [
      "GST Amount",
      `${INDIAN_RUPEE_SIGN} ${tenant.gst_amount}`,
    ],
    [
      "Monthly Fixed Electricity Bill",
      tenant.monthly_electricity_bill != null
        ? `${INDIAN_RUPEE_SIGN} ${tenant.monthly_electricity_bill}`
        : null,
    ],
    [
      "Electricity Per Unit Charge",
      tenant.electricity_per_unit_charge != null
        ? `${INDIAN_RUPEE_SIGN} ${tenant.electricity_per_unit_charge}`
        : null,
    ],
    [
      "Maintenance Charges",
      `${INDIAN_RUPEE_SIGN} ${tenant.maintenance_charges}`,
    ],
    ["Note", tenant.notes || "-"],
    ["Total Rent Amount", `${INDIAN_RUPEE_SIGN} ${tenant.total_rent_amount}`],
  ].filter(Boolean);

  return (
    <TableContainer>
      <Table size="small" aria-label="tenant details table">
        <StyledTableBody>
          {tenantDetails.map(([label, value]) => (
            <TableBodyRow key={label}>
              <TableCell sx={labelCellStyle}>{label}</TableCell>
              <TableCell sx={colonCellStyle}>:</TableCell>
              <TableCell sx={valueCellStyle}>{value}</TableCell>
            </TableBodyRow>
          ))}
        </StyledTableBody>
      </Table>
    </TableContainer>
  );
};

export default TenantDetailsTable;
